import { CATLIST, CATLIST_ERROR, CATLIST_ISLOADING } from '../actions/fetch_catlist'; 

export const catlist = (state = [], action) => {
  switch (action.type) {
    case CATLIST:
      return action.payload.data
    default:
      return state
  }
}

export function catlist_isloading(state = true, action) {
  switch (action.type) {
    case CATLIST_ISLOADING:
      return action.isLoading;
    default:
        return state;
  }
}


export function catlist_error(state = false, action) {
  switch (action.type) {
    case CATLIST_ERROR:
      return action.hasErrored;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_catlist.js